import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  FileComment,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.workflow}files/fileComment`;

export interface AddFileCommentCommandPayload {
  fileId: string;
  content: string;
}

export const addFileCommentRequest = (
  payload: AddFileCommentCommandPayload,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: { method: SUPPORTED_METHODS.POST, json: payload },
});

export const addFileCommentCommand = async (
  payload: AddFileCommentCommandPayload,
): Promise<BackResponse<FileComment> | BackResponseFailure> => {
  try {
    return await executeQuery<BackResponse<FileComment>>(
      addFileCommentRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
